module.exports = __webpack_public_path__ + "img/icon-tap-water.c5fd7265.png";